import type { TOC } from '@ember/component/template-only';

interface HotelAndMarketRevenueInsightLoadingStateTitleSignature {
  Args: {
    centered?: boolean;
  };
}

const HotelAndMarketRevenueInsightLoadingStateTitle = <template>
  {{! Container is used for vertical positioning (only used in the title boxes of Insight pages) }}
  <div class="loading-state-title-container {{if @centered 'centered'}}">
    <p class="loading-pulse--col-3"></p>
  </div>
</template> satisfies TOC<HotelAndMarketRevenueInsightLoadingStateTitleSignature>;

export default HotelAndMarketRevenueInsightLoadingStateTitle;
